import script from "./topicItem.vue?vue&type=script&setup=true&lang=js"
export * from "./topicItem.vue?vue&type=script&setup=true&lang=js"

import "./topicItem.vue?vue&type=style&index=0&id=d58d4e9a&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d58d4e9a"]])

export default __exports__